Vue = require 'vue'
VueResource = require 'vue-resource'
Vue.use(VueResource)

class Api extends Vue
  constructor: (base_url=null) ->
    if base_url
      @base_url = base_url
    else
      @base_url = process.env.API_URL

    super()

  url: (path) ->
    "#{@base_url}#{path}"

  get: (path, params, options) ->
    @$http.get(@url(path), params).then ((response) =>
      options.success response if options.success
    ), ((response) =>
      options.failure response if options.failure
    )

  post: (path, params, options) ->
    @$http.post(@url(path), params).then ((response) =>
      options.success response if options.success
    ), ((response) =>
      options.failure response if options.failure
    )

  put: (path, params, options) ->
    @$http.put(@url(path), params).then ((response) =>
      options.success response if options.success
    ), ((response) =>
      options.failure response if options.failure
    )

  delete: (path, params, options) ->
    params['_method'] = 'DELETE'

    @$http.delete(@url(path), params).then ((response) =>
      options.success response if options.success
    ), ((response) =>
      options.failure response if options.failure
    )

exports.api = (base_url=null) -> new Api(base_url)



// WEBPACK FOOTER //
// ./src/api.coffee